import React from "react";
import { Button } from "react-bootstrap";

/**
 * Right-side slide-in drawer, matching the InvoiceTransactionMatcher pattern
 * (backdrop + fixed right panel that animates its width). Used for editors that
 * benefit from more space + keeping the invoice visible context, instead of a
 * centered modal — e.g. invoice rules and approval rules.
 */
type Props = {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  /** Drawer width when open (default 70%). */
  width?: string;
  children: React.ReactNode;
};

const RightDrawer: React.FC<Props> = ({
  open,
  onClose,
  title,
  width = "70%",
  children,
}) => {
  return (
    <>
      {/* Backdrop */}
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1049,
          }}
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        className={`docuclipper-right-drawer ${open ? "open" : "closed"}`}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: open ? width : "0",
          backgroundColor: "#fff",
          boxShadow: "-2px 0 10px rgba(0,0,0,0.1)",
          transition: "width 0.3s ease-in-out",
          zIndex: 1050,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "1rem 1.5rem",
            borderBottom: "1px solid #dee2e6",
            backgroundColor: "#f8f9fa",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <h5 className="mb-0">{title}</h5>
          <Button variant="outline-secondary" size="sm" onClick={onClose}>
            Close
          </Button>
        </div>

        {/* Body — only mount content while open so heavy editors reset state on
            open and don't run when hidden (matches modal behavior). */}
        <div style={{ flex: 1, overflowY: "auto", padding: "1rem 1.5rem" }}>
          {open && children}
        </div>
      </div>
    </>
  );
};

export default RightDrawer;
